var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.lazyLoad)?_c('img',{staticClass:"book-cover-container",attrs:{"src":_vm.bookCoverPath,"alt":_vm.alternativeText},on:{"error":_vm.handleError}}):_c('v-img',{staticClass:"book-cover-container",attrs:{"lazy-src":_vm.bookCoverPath,"src":_vm.bookCoverPath,"alt":_vm.alternativeText,"eager":_vm.lazyLoad},on:{"error":_vm.handleError}})
}
var staticRenderFns = []

export { render, staticRenderFns }